import type { ShiftTodayListItem } from '@/api/shifts';

export type ShiftLocation = {
  position: { lat: number; lng: number };
  shifts: ShiftTodayListItem[];
};

// Most urgent first: a location shows the status that needs attention soonest
// (no check-in yet, then in progress, then finished).
const STATUS_COLOR_PRIORITY = ['error', 'warning', 'success', 'grey'];

function hasCoordinates(shift: ShiftTodayListItem): boolean {
  return typeof shift.latitude === 'number' && typeof shift.longitude === 'number';
}

// One marker per address: shifts at the same coordinates (two professionals with
// one patient, a patient pinned twice) share it. Shifts without coordinates are
// left out of the map.
export function groupShiftsByLocation(shifts: ShiftTodayListItem[]): ShiftLocation[] {
  const byKey = new Map<string, ShiftLocation>();
  shifts.filter(hasCoordinates).forEach((shift) => {
    const lat = shift.latitude as number;
    const lng = shift.longitude as number;
    const key = `${lat},${lng}`;
    const location = byKey.get(key) ?? { position: { lat, lng }, shifts: [] };
    location.shifts.push(shift);
    byKey.set(key, location);
  });

  return [...byKey.values()];
}

export function locationStatusColor(location: ShiftLocation): string {
  const colors = location.shifts.map(shift => shift.status.color);

  return STATUS_COLOR_PRIORITY.find(color => colors.includes(color)) ?? colors[0];
}
